import { EmptyDataStateIcon } from "./icons/EmptyDataStateIcon";

export const EmptyState = ({
  text = "Chưa có dữ liệu để hiển thị",
  variant = "centered",
  className = "",
}) => {
  if (variant === "padded") {
    return (
      <div
        className={`flex flex-col items-center justify-center py-[40px] px-[20px] ${className}`}
      >
        <EmptyDataStateIcon />
        <p className="mt-[12px] text-[14px] text-[#636369] m-0 text-center">
          {text}
        </p>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col items-center justify-center flex-1 text-center ${className}`}
    >
      <EmptyDataStateIcon />
      <p className="mt-[12px] text-[14px] text-[#636369]">{text}</p>
    </div>
  );
};
